import "./Machines.module.css";
import CorporateCoffeeCapsulesAndMachines from "@/reusable_sections/Header";
import MachinesCafe from "./sections/MachinesCafe";
export default function MachinesPage() {
  return <div>
      <CorporateCoffeeCapsulesAndMachines />
      <MachinesCafe />
    </div>;
}